  (function(){
    let aSec = document.querySelector(".announcement-bar.shopify-section");
    if(!aSec) {
      let announcement = document.createElement('div');
      announcement.className = "shopify-section shopify-section-group-header-group announcement-bar";
      announcement.innerHTML = '<div class="bg-white bg-announcement"><div class="announcement-bar text-center container"></div></div>';
      document.querySelector("header").prepend(announcement);
      aSec = announcement;
    }
    if(aSec.children && aSec.children.length > 0 && aSec.children[0]){
      aSec.children[0].classList.add("bg-announcement");
    if(location.pathname != '/')
      aSec.children[0].classList.add("bg-announcement-fixed");

    }
    bSec = aSec.querySelector(".announcement-bar.container");
    bSec.innerHTML = document.querySelector(".as-announcement-contents").outerHTML;
    Array.from(bSec.querySelectorAll(".ac-link")).every((link) => {
      if(link.dataset.href != "none") {
        link.classList.add("ac-link-clickable");
        link.addEventListener("click", () => {
          window.location.href = link.dataset.href;
        });
      }
      return true;
    });

  })()